import React, { useEffect, useMemo, useState } from 'react'
import { Tabs, Tab, Box, Button, Chip } from "@mui/material";
import InterfaceDiscoverConfig from '../Interface/InterfaceDiscoverConfig';
import NVRDiscover from './NVRDiscover';
import CameraDiscover from './CameraDiscover';
import { getDiscoverDeviceList } from '../../../services/onVifService';
import { SuccessToast } from '../../../CustomHooks/SuccessToast';
import { ErrorToast } from '../../../CustomHooks/ErrorToast';
import AlertTemplateMessage from '../../Configuration/AlertTemplate/AlertTemplateMessage';
import InfoIcon from '@mui/icons-material/Info';

const DiscoverDevices = () => {
    const [activeTab, setActiveTab] = useState(0);
    const [discoverDeviceList, setDiscoverDeviceList] = useState([]);
    const [loading, setLoading] = useState(true);

    const getDiscoverDeviceListByType = (discoverDeviceList, deviceType) => {
        if(deviceType === "NVR/DVR") {
            return discoverDeviceList.filter(device => device.DeviceType !== "Camera");
        }
        if(deviceType === "Camera") {
            return discoverDeviceList.filter(device => device.DeviceType === "Camera");
        }
        return discoverDeviceList.filter(device => device.DeviceType === deviceType);
    }

    const showDiscoverInterfaceForm = async () => {
        // show both loading flags so UI can reflect discovery in progress
        setLoading(true);
        //setIsDiscoverLoading(true);
        const payload = {
            DeviceType: "",
        }
        try {
            const response = await getDiscoverDeviceList(payload);
            if (response && response.Status === "success") {
                setDiscoverDeviceList(response.Data);
                //SuccessToast("Onvif Device Discover Successfully");
                //setShowInterfaceDiscoverForm(true);
            } else {
                setDiscoverDeviceList([]);
                //ErrorToast("Onvif Device Discover Failed");
            }
        } catch (err) {
            console.log(err);
            //ErrorToast("Error discovering onvif devices");
        } finally {
            //setIsDiscoverLoading(false);
            setLoading(false);
        }
    };


    useEffect(() => {
        showDiscoverInterfaceForm();

        return () => {
            setDiscoverDeviceList([]);
        }
    }, [])

    const NVRDVRList = useMemo(() => getDiscoverDeviceListByType(discoverDeviceList, "NVR/DVR"), [discoverDeviceList]);
    const cameraList = useMemo(() => getDiscoverDeviceListByType(discoverDeviceList, "Camera"), [discoverDeviceList]);

  return (
     <div className='p-3'>
                 {/* <AlertTemplateMessage type="info" message="ONVIF Auto-Discovery is only available for devices on the same local network (LAN) and subnet. Ensure your camera and this application are connected to the same network segment for successful discovery."/> */}
       
       <div className="SiteMainContainer SiteTableMainDiv">
             <div className="SiteMainHeightDiv">
                <div className="col-lg-12 m-0 TabulerReportMainDiv MatReactTableDiv" style={{ height: "calc(100vh - 170px)" }}>
                      <Box sx={{ borderBottom: 1, borderColor: "divider", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                          <Tabs
                              value={activeTab}
                              onChange={(e, val) => setActiveTab(val)}
                              textColor="primary"
                              indicatorColor="primary"
                          >
                              <Tab label={`${NVRDVRList.length} NVR / DVR `} style={{fontWeight:"700"}}/>
                              <Tab label={`${cameraList.length} Camera`} style={{fontWeight:"700"}}/>
                          </Tabs>
                          <div className='OnvifAlertMessage'>
                                <InfoIcon color="error" style={{ marginRight: "5px" }} />
                            <h5>Onvif Auto-Discovery is only available for devices on the same local network (LAN) and subnet. Ensure your camera and this application are connected to the same network segment for successful discovery.</h5>
                            </div>
                      </Box>

                      {/* Tab Content */}
                      <Box className="p-3">
                          {activeTab === 0 && <NVRDiscover discoverList={NVRDVRList} loading={loading} />}
                          {activeTab === 1 && <CameraDiscover discoverList={cameraList} loading={loading} />}
                      </Box>
                </div>
            </div>
            </div>
     </div>
  )
}

export default DiscoverDevices